import { gql } from '@apollo/client';
import eventFragment from './eventFragment';
import eventAssignmentsFragment from './eventAssignmentsFragment';

const FINALIZE_EVENT = gql`
  mutation finalizeEvent($event: EditEventInput!) {
    finalizeEvent(event: $event) {
      ...EventFields
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${eventFragment}
  ${eventAssignmentsFragment}
`;

export default FINALIZE_EVENT;
